// FaqArticle.js
'use strict';
import { connect } from 'react-redux';
import getIntercomArticleData from '../selector/getIntercomArticleData.js';
import FaqArticle from '../component/FaqArticle.jsx';
import { withTranslation } from 'react-i18next';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { FAQ_SUPPORTED_LANGUAGES } from '../RemoteConfigKeys.js';
import { getCurrentFaqLanguage } from '../resource/getCurrentLanguage.js';

const mapStateToProps = (state, { id, i18n }) => {
  const faqSupportedLanguages = getRemoteConfigData(
    state,
    FAQ_SUPPORTED_LANGUAGES
  );
  const language = getCurrentFaqLanguage({
    i18n,
    supportedLanguages: faqSupportedLanguages,
  });
  return {
    id,
    title: getIntercomArticleData(state, [id, language], 'title'),
    body: getIntercomArticleData(state, [id, language], 'body'),
  };
};

export default withTranslation()(connect(mapStateToProps, null)(FaqArticle));
